import { Head } from "@/components/Head";
import { Button } from "@/components/Button";
import { Section, Eyebrow } from "@/components/Section";

export function NotFoundPage() {
  return (
    <>
      <Head
        title="Page not found — ServiTrex"
        description="The page you requested is not available. Head back to the ServiTrex marketing site."
      />
      <Section className="pt-20 sm:pt-24">
        <div className="max-w-2xl">
          <Eyebrow>404</Eyebrow>
          <h1 className="text-4xl sm:text-5xl">That page is off the board.</h1>
          <p className="mt-5 text-lg text-muted">
            The link may be outdated, or the page may have moved. Try the home page,
            pricing, or request a demo.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button to="/" size="lg">
              Back home
            </Button>
            <Button to="/demo" variant="secondary" size="lg">
              Book a demo
            </Button>
          </div>
        </div>
      </Section>
    </>
  );
}
